export const WHATSAPP_LINK =
  "https://wa.me/553196335635?text=Ol%C3%A1%20Luiz!%20Vi%20seu%20portf%C3%B3lio%20e%20quero%20or%C3%A7ar%20um%20projeto.";
export const EMAIL = "luizhenriqueho436@gmail.com";
export const PHONE_DISPLAY = "+55 31 9633-5635";

export const NAV_LINKS = [
  { id: "sobre", label: "Sobre", testid: "nav-link-about" },
  { id: "servicos", label: "Serviços", testid: "nav-link-services" },
  { id: "projetos", label: "Projetos", testid: "nav-link-portfolio" },
  { id: "planos", label: "Planos", testid: "nav-link-plans" },
  { id: "depoimentos", label: "Depoimentos", testid: "nav-link-testimonials" },
  { id: "contato", label: "Contato", testid: "nav-link-contact" },
];

export const SERVICES = [
  {
    id: "corporativo",
    icon: "Building2",
    badge: "Corporativo",
    title: "Sites para Empresas",
    description:
      "Sites institucionais e landing pages de alta conversão que passam autoridade, carregam em menos de 1 segundo e transformam visitantes em clientes.",
    points: ["Layout sob medida", "SEO estratégico", "Captura de leads"],
  },
  {
    id: "games",
    icon: "Gamepad2",
    badge: "Gaming Edge",
    title: "Sites para Jogos & eSports",
    description:
      "Plataformas imersivas para lançamento de games, estúdios indie e comunidades: visual dark impactante, trailers integrados e sistemas de pré-venda.",
    points: ["Landing pages de games", "Portais de torneios", "Efeitos 3D & animação"],
  },
  {
    id: "performance",
    icon: "Gauge",
    badge: "Performance",
    title: "Otimização & SEO",
    description:
      "Auditoria completa de velocidade e ranqueamento. Pontuação máxima no Lighthouse, Core Web Vitals no verde e seu site no topo do Google.",
    points: ["Carregamento < 1s", "Core Web Vitals", "SEO técnico"],
  },
  {
    id: "suporte",
    icon: "ShieldCheck",
    badge: "Contínuo",
    title: "Manutenção & Suporte",
    description:
      "Seu site sempre no ar, seguro e atualizado. Monitoramento, backups, atualizações de conteúdo e hospedagem de alta performance.",
    points: ["Segurança ativa", "Backups automáticos", "Atualizações mensais"],
  },
];

export const PROJECTS = [
  {
    id: "aetheria",
    title: "Aetheria Chronicles",
    category: "games",
    categoryLabel: "Games & eSports",
    tagline: "Site oficial de RPG dark fantasy",
    description:
      "Website imersivo para lançamento de um RPG dark fantasy: abertura cinematográfica, trilha ambiente, galeria de personagens com parallax e sistema de pré-registro que disparou a base de jogadores antes do lançamento.",
    stack: ["React", "Three.js", "Tailwind", "Framer Motion"],
    stat: "+180% de pré-registros",
    visual: "game",
    short: "AETHERIA",
    slug: "aetheria.com.br",
  },
  {
    id: "vanguard",
    title: "Vanguard Logistics",
    category: "empresarial",
    categoryLabel: "Empresarial",
    tagline: "Portal corporativo com painel em tempo real",
    description:
      "Portal institucional para empresa de logística com dashboard de operações em tempo real, rastreamento de cargas e área do cliente. Autoridade corporativa com velocidade extrema.",
    stack: ["React", "Node.js", "Recharts", "MongoDB"],
    stat: "Carregamento em 0.8s",
    visual: "dashboard",
    short: "VANGUARD",
    slug: "vanguardlog.com.br",
  },
  {
    id: "cyberarena",
    title: "CyberArena eSports",
    category: "games",
    categoryLabel: "Games & eSports",
    tagline: "Plataforma de torneios com tabelas ao vivo",
    description:
      "Plataforma completa de torneios gamer: chaveamentos atualizados ao vivo, contagem regressiva para partidas, perfis de times e integração com streaming. Visual cyberpunk que virou marca da comunidade.",
    stack: ["Next.js", "WebSockets", "Tailwind", "PostgreSQL"],
    stat: "+12 mil jogadores inscritos",
    visual: "game",
    short: "CYBERARENA",
    slug: "cyberarena.gg",
  },
  {
    id: "nexus",
    title: "Nexus Financial",
    category: "empresarial",
    categoryLabel: "Empresarial",
    tagline: "Landing page de fintech com gráficos animados",
    description:
      "Landing page de alta conversão para fintech: gráficos animados, calculadora interativa de investimentos e funil de captura de leads otimizado por testes A/B.",
    stack: ["React", "Framer Motion", "APIs REST", "Analytics"],
    stat: "+64% de conversão de leads",
    visual: "dashboard",
    short: "NEXUS",
    slug: "nexusfin.com.br",
  },
  {
    id: "shadowblade",
    title: "ShadowBlade Studio",
    category: "games",
    categoryLabel: "Games & eSports",
    tagline: "Portfólio de estúdio de modelos 3D para jogos",
    description:
      "Portfólio digital para estúdio de animação e modelagem 3D: vitrine de personagens com visualizador interativo, reels de animação e página de comissões que lotou a agenda do estúdio.",
    stack: ["React", "Three.js", "GSAP", "Headless CMS"],
    stat: "Agenda lotada por 6 meses",
    visual: "game",
    short: "SHADOWBLADE",
    slug: "shadowblade.studio",
  },
  {
    id: "apex",
    title: "Apex Consulting",
    category: "empresarial",
    categoryLabel: "Empresarial",
    tagline: "Site institucional com agendamento direto",
    description:
      "Site institucional para consultoria empresarial com agendamento de reuniões integrado, blog otimizado para SEO e área de cases que triplicou o fluxo de propostas recebidas.",
    stack: ["Next.js", "Tailwind", "Calendly API", "SEO"],
    stat: "3x mais propostas recebidas",
    visual: "business",
    short: "APEX",
    slug: "apexconsult.com.br",
  },
];

export const TESTIMONIALS = [
  {
    id: "ricardo",
    name: "Ricardo Almeida",
    role: "CEO — Vertex Agência Digital",
    initials: "RA",
    quote:
      "O Luiz entregou nosso site em tempo recorde e com uma qualidade que eu não via nem em agências grandes. Profissionalismo do início ao fim — cada detalhe pensado para converter.",
  },
  {
    id: "marina",
    name: "Marina Duarte",
    role: "Desenvolvedora Indie — Studio Lumen",
    initials: "MD",
    quote:
      "A landing page do meu jogo ficou simplesmente cinematográfica. Os jogadores elogiaram o site antes mesmo de elogiar o jogo. O impacto visual superou tudo que eu imaginei.",
  },
  {
    id: "felipe",
    name: "Felipe Costa",
    role: "Gerente de Marketing — Orbital Games",
    initials: "FC",
    quote:
      "Depois do novo site, nossas conversões de leads subiram mais de 60%. O Luiz entende de código, de design e de negócio — uma combinação raríssima de encontrar.",
  },
];

export const SOCIALS = [
  { name: "GitHub", url: "https://github.com", icon: "Github", testid: "contact-social-github" },
  { name: "LinkedIn", url: "https://linkedin.com", icon: "Linkedin", testid: "contact-social-linkedin" },
  { name: "Instagram", url: "https://instagram.com", icon: "Instagram", testid: "contact-social-instagram" },
];

export const PROCESS = [
  {
    n: "01",
    icon: "Search",
    title: "Descoberta",
    duration: "1-2 dias",
    text: "Conversa direta para entender seu negócio, público e metas. Saio com um briefing claro e uma proposta sem letras miúdas.",
  },
  {
    n: "02",
    icon: "PenTool",
    title: "Design",
    duration: "3-5 dias",
    text: "Protótipo navegável com a identidade da sua marca. Você aprova cada tela antes de qualquer linha de código.",
  },
  {
    n: "03",
    icon: "Code2",
    title: "Desenvolvimento",
    duration: "1-3 semanas",
    text: "Código limpo, animações refinadas e performance máxima. Acompanhe o progresso em tempo real pela área do cliente.",
  },
  {
    n: "04",
    icon: "Rocket",
    title: "Lançamento",
    duration: "1 dia",
    text: "Deploy, domínio, SEO técnico e monitoramento configurados. Seu site no ar, seguro e pronto para converter.",
  },
];

export const STACK = [
  { name: "React", tag: "Frontend", level: 95 },
  { name: "Next.js", tag: "Fullstack", level: 90 },
  { name: "Tailwind CSS", tag: "Estilo", level: 95 },
  { name: "Framer Motion", tag: "Animação", level: 92 },
  { name: "Node.js", tag: "Backend", level: 85 },
  { name: "Three.js", tag: "3D & WebGL", level: 78 },
  { name: "SEO Técnico", tag: "Ranqueamento", level: 88 },
  { name: "UI/UX Design", tag: "Conversão", level: 90 },
];

export const PLANS = [
  {
    lookup_key: "site_empresarial",
    name: "Site Empresarial",
    price: "Valor a combinar",
    priceNote: "fechamos pelo WhatsApp",
    tagline: "Autoridade digital para sua empresa vender mais.",
    icon: "Building2",
    features: [
      "Site institucional ou landing page de conversão",
      "Design exclusivo alinhado à sua marca",
      "SEO técnico + Google Business",
      "Integração com WhatsApp e captura de leads",
      "Responsivo, rápido (< 1s) e seguro",
      "Entrega em até 3 semanas",
    ],
  },
  {
    lookup_key: "site_games",
    name: "Site de Jogo / eSports",
    price: "Valor a combinar",
    priceNote: "fechamos pelo WhatsApp",
    tagline: "Experiência imersiva para lançar seu jogo ou time.",
    icon: "Gamepad2",
    featured: true,
    features: [
      "Landing page cinematográfica com animações 3D",
      "Trailer, galeria e pré-registro integrados",
      "Portal de torneios ou página de time",
      "Integração com Discord, Twitch e Steam",
      "Visual dark de alto impacto",
      "Entrega em até 4 semanas",
    ],
  },
  {
    lookup_key: "manutencao_mensal",
    name: "Manutenção Mensal",
    price: "Valor a combinar",
    priceNote: "fechamos pelo WhatsApp",
    tagline: "Seu site sempre no ar, seguro e atualizado.",
    icon: "Wrench",
    features: [
      "Monitoramento 24/7 e backups automáticos",
      "Atualizações de conteúdo mensais",
      "Correções e ajustes de segurança",
      "Relatório de performance",
      "Suporte prioritário no WhatsApp",
    ],
  },
];

export const DEPOSIT_PLAN = {
  lookup_key: "sinal_projeto",
  name: "Garantir sua vaga na agenda",
  price: "Valor a combinar",
  priceNote: "fechamos pelo WhatsApp",
  tagline: "Quer garantir sua vaga na agenda antes de fechar o projeto completo? Me chame no WhatsApp e já começamos o briefing.",
};

export const MARQUEE_ITEMS = [
  "REACT",
  "NEXT.JS",
  "TAILWIND CSS",
  "NODE.JS",
  "LANDING PAGES GAMER",
  "THREE.JS",
  "ANIMAÇÕES",
  "SEO ESTRATÉGICO",
  "PERFORMANCE EXTREMA",
  "SITES CORPORATIVOS",
];
